module.exports = __webpack_public_path__ + "img/wl.bc05ae40.png";